module.exports = __webpack_public_path__ + "static/media/speaker.4bb397ee.svg";